import { isBrowser } from './isBrowser'
import { SCROLL_FIXED_OFFSET } from '../components/containers/Header'

export function isHeaderFixed (leaderboardHeight, mainContentContainerMarginTop) {
  return isBrowser()
    ? window.pageYOffset >= leaderboardHeight + mainContentContainerMarginTop + SCROLL_FIXED_OFFSET
    : false
}
